import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    parts: null,
    // parts: [
    //   "Краеведческая и&nbsp;национальная литература и&nbsp;библиография",
    //   "Реклама и&nbsp;маркетинг",
    //   "Регистрация читателей и&nbsp;статистика",
    //   "Формирование каталогов и&nbsp;информационно&#8209;библиографическое обслуживание",
    //   "Научно&#8209;методическая деятельность",
    //   "Обслуживание читателей",
    //   "Автоматизация библиотечной деятельности",
    //   "Служба безопасности",
    //   "Реставрация и&nbsp;консервация книжных фондов",
    //   "Экономика и&nbsp;финансы",
    // ],
    portrets: null,
    fio: null,
    // portrets: [
    //   [
    //     ["egorova", 0],
    //     ["limonova", 1],
    //     ["sergeeva", 2],
    //     ["popova", 3],
    //     ["medvedeva", 4],
    //     ["kozlova", 5],
    //     ["chuzhikova", 6]
    //   ],
    //   [
    //     ["pronina", 7],
    //     ["pendur", 8],
    //     ["borovkova", 9]
    //   ],
    //   [
    //     ["zavrazhina", 10],
    //     ["samsonova", 11]
    //   ],
    //   [
    //     ["sutygina", 12],
    //     ["kalacheva", 13],
    //     ["mirgalieva", 14],
    //     ["ezhova", 15],
    //     ["veselkova", 16]
    //   ],
    //   [
    //     ["egorovaev", 17],
    //     ["suncova", 18]
    //   ],
    //   [
    //     ["russkih", 19],
    //     ["agafonov", 20]
    //   ],
    //   [
    //     // ["abugova", 21], //?
    //     ["dolgov", 21], //?
    //     ["hohrjkova", 22] //?
    //   ],
    //   [
    //     ["maikov", 23]
    //   ],
    //   [
    //     ["nagovicyna", 24],
    //     ["chelnokova", 25]
    //   ],
    //   [
    //     ["krivosheina", 26]
    //   ],

    // ],
    // fio: [
    //   ["Егорова", "Любовь Ивановна"],
    //   ["Лимонова", "Надежда Петровна"],
    //   ["Сергеева", "Галина Александровна"],
    //   ["Попова", "Людмила Михайловна"],
    //   ["Медведева", "Ангелина Николаевна"],
    //   ["Козлова", "Валентина Аркадьевна"],
    //   ["Чужикова", "Людмила Васильевна"],
    //   ["Пронина", "Надежда Михайловна"],
    //   ["Пендюр", "Татьяна Ивановна"],
    //   ["Боровкова", "Дарина Андреевна"],
    //   ["Завражина", "Елена Дмитриевна"],
    //   ["Самсонова", "Екатерина Александровна"],
    //   ["Сутыгина", "Ирина Евгеньевна"],
    //   ["Калачева", "Светлана Степановна"],
    //   ["Миргалиева", "Файруза Гимрановна"],
    //   ["Ежова", "Надежда Эдуардовна"],
    //   ["Веселкова", "Гульнара Фаритовна"],
    //   ["Егорова", "Елена Валерьевна"],
    //   ["Сунцова", "Ольга Сергеевна"],
    //   ["Русских", "Светлана Юрьевна"],
    //   ["Агафонов", "Илья Сергеевич"],
    //   // ["Абугова", "Ирина Геннадьевна"],
    //   ["Долгов", "Александр Николаевич"],
    //   ["Хохрякова", "Елена Владимировна"],
    //   ["Майков", "Юрий Александрович"],
    //   ["Наговицына", "Светлана Исламовна"],
    //   ["Челнокова", "Ольга Александровна"],
    //   ["Кривошеина", "Мария Вячеславовна"],
    // ],
    PersonaStatus: "",
  },
  getters: {
    PERSONA: state => {
      return state.PersonaStatus
    },
    PARTS: state => {
      return state.parts
    },
    PORTRETS: state => {
      return state.portrets
    },
    FIO: state => {
      return state.fio
    }
  },
  mutations: {
    personaStatusView: (state, status) => {
      state.PersonaStatus = status
    },
    portretsSet: (state, status) => {
      state.portrets = status
    },
    partsSet: (state, status) => {
      state.parts = status
    },
    fioSet: (state, status) => {
      state.fio = status
    },
  },
  actions: {
  },
  modules: {
  }
})
